export default {"src":"/_next/static/media/IPHONE.155430c0.svg","height":18,"width":14,"blurWidth":0,"blurHeight":0};